import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Table from '../Table';
import Formatter from '../Formatter';
import Button from '../Button';

const renderMessageRow = (operazione, message, idx, onRimuovi) => (
  <tr key={idx}>
    <td className="snackbar__timeStamp">
      <Formatter
        tipo="date"
        valore={operazione.timeStamp}
      />
      -
      <Formatter
        tipo="hour"
        valore={operazione.timeStamp}
      />
    </td>
    <td>{message}</td>
    <td className="snackbar__actions">
      <Button
        onClick={() => onRimuovi(idx)}
        text
      >
        OK
      </Button>
      {operazione.actions}
    </td>
  </tr>
);

class TabellaOperazioneSincrona extends Component {
  constructor(props) {
    super(props);

    this.state = {
      operazione: props.operazione,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { operazione } = this.props;

    if (nextProps.operazione.index !== operazione.index) {
      this.setState({
        operazione: nextProps.operazione,
      });
    }
  }

  rimuoviErrore = (index) => {
    const { rimuoviOperazione } = this.props;
    const { operazione } = this.state;

    const op = operazione;
    op.message = op.message.filter((x, i) => i !== index);

    if (op.message.length > 0) {
      this.setState({
        operazione: op,
      });
    } else {
      rimuoviOperazione(operazione.index);
    }
  };

  render() {
    const {
      rimuoviOperazione,
    } = this.props;
    const {
      operazione,
    } = this.state;

    return (
      <Table className="snackbar__tabellaErrori">
        <Table.Head>
          <tr>
            <th style={{ width: '20%' }}>Data e ora</th>
            <th style={{ width: '70%' }}>Errore</th>
            <th style={{ width: '10%' }}>Azioni</th>
          </tr>
        </Table.Head>
        <Table.Body>
          {
            Array.isArray(operazione.message)
              ? operazione.message.map(
                (x, i) => renderMessageRow(operazione, x, i, this.rimuoviErrore),
              )
              : renderMessageRow(operazione, operazione.content
                || operazione.message, operazione.index, rimuoviOperazione)
          }
        </Table.Body>
      </Table>
    );
  }
}

TabellaOperazioneSincrona.propTypes = {
  operazione: PropTypes.shape({
    index: PropTypes.number,
    actions: PropTypes.node,
    timeStamp: PropTypes.any,
  }),
  rimuoviOperazione: PropTypes.func,
};

TabellaOperazioneSincrona.defaultProps = {
  operazione: null,
  rimuoviOperazione: null,
};

export default TabellaOperazioneSincrona;
